// Application Version Configuration
export const APP_VERSION = "1.0.0";
export const BUILD_DATE = "2024-12-01";
export const VERSION_NOTES = "Initial production release";

// Formatted version string for display
export const getVersionString = () => `v${APP_VERSION}`;
export const getBuildString = () => `Build: Dec 1, 2024`;
export const getFullVersionString = () => `Red Bridge Farm Feed Co. ${getVersionString()} | ${getBuildString()}`;
export const getCopyrightString = () => `© 2024 Red Bridge Farm Feed Co. | ${getVersionString()}`;
